"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backgroundClip;
function backgroundClip() {
  return null;
}